// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// NgRx
import { setFolderableOperation } from './folderable-operation.action';
export const FOLDERABLE_OPERATION_SLICE_KEY = 'folderableOperation';
/**
 * Reducer to save the operation to perform.
 *
 * Unlike `selectedFolderableOperation`, there is no selected item to perform the operation on.
 */
export const folderableOperation = createReducer(null, on(setFolderableOperation, (_, action) => {
    return action.operation;
}));
